import { gql, useMutation } from "@apollo/client";

const ADD_PLAYER_TO_TEAM_SEASON = gql`
    mutation AddPlayerToTeamSeason($profileId: Int!, $teamId: Int!, $seasonId: Int!, $role: Int) {
        invitePlayer(profileId: $profileId, teamId: $teamId, seasonId: $seasonId, role: $role) {
            success
        }
    }
`;

export default function AddPlayerToTeamSeasonMutation() {
    return useMutation(ADD_PLAYER_TO_TEAM_SEASON);
}

